/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import * as _ from 'lodash';

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormControl,
  Button,
  Alert,
  Snackbar,
} from '@mui/material';
import { spacing } from '@mui/system';
import axios from '../../CustomAxios';
import Loading from '../components/Loading';

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function DefaultTextFields({ role }) {
  const [apPermission, setApPermission] = useState([]);
  const [customerPermission, setCustomerPermission] = useState([]);
  const [permissions, setPermissions] = useState({});
  const [roleName, setRoleName] = useState(role?.name);
  const [userType, setUserType] = useState(role?.user_type);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  useEffect(() => {
    getPermissions();
    PermissionOptions();
  }, []);

  const getPermissions = () => {
    const perms = {};
    role?.permissions?.map((permission) => {
      perms[permission] = true;
    });
    setPermissions(perms);
  };

  useEffect(() => {}, [permissions]);

  const PermissionOptions = async () => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      const { data } = await axios.get(`/api/v1/${userData.type}/role/permissions`, config);

      if (data.success) {
        setApPermission(data.data.ap_user_permissions);
        setCustomerPermission(data.data.customer_user_permissions);
      }
      setLoader(false);
    } catch (e) {
      setLoader(false);
      console.log(e);
    }
  };

  const EditRole = async () => {
    let final = [];
    Object.keys(permissions).map((permission, i) => {
      if (permission) {
        if (permissions[permission]) {
          final.push(permission);
        }
      }
    });
    try {
      if (!roleName) {
        setErr('Please enter a role name');
        snackRef.current.click();
        return;
      }
      if (!final.length) {
        setErr('Select atleast one permission');
        snackRef.current.click();
        return;
      }
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/role/${role?.id}`,
        {
          user_type: userType,
          role_name: roleName,
          permissions: final,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr('');
        snackRef.current.click();
        navigate('/dashboard/roles');
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      console.log(e);
      snackRef.current.click();
    }
  };
  const handleChange = (event) => {
    if (userType === 'ap_company_user') {
      const newPermissionMap = {
        ...permissions,
        [event.target.name]: event.target.checked,
      };
      setPermissions(populatePermissionMap(newPermissionMap));
    } else {
      setPermissions({
        ...permissions,
        [event.target.name]: event.target.checked,
      });
    }
  };

  /**
   *
   * @param {object} permissionsMap
   * @returns
   */
  function populatePermissionMap(permissionsMap) {
    const clonedMap = structuredClone(permissionsMap);
    if (clonedMap['edit_job_details']) {
      // Edit Job Permission
      [
        'view_ap_company_list',
        'view_customer_company_list',
        'view_job_details',
        'view_ap_user_list',
        'view_customer_company_user_list',
        'customer_company_plate_list_view',
        'view_plate_list',
      ].forEach((pm) => {
        clonedMap[pm] = true;
      });
    }

    // Edit AP User Permissions
    if (clonedMap['update_ap_user']) {
      ['view_ap_company_list', 'view_ap_user_profile', 'view_role'].forEach((pm) => {
        clonedMap[pm] = true;
      });
    }

    // Edit Customer Company User
    if (clonedMap['update_customer_company_user']) {
      ['view_customer_company_list', 'view_customer_company_user_profile', 'view_role'].forEach(
        (pm) => {
          clonedMap[pm] = true;
        }
      );
    }

    // Edit Customer Company Profile
    if (clonedMap['update_customer_company']) {
      ['view_customer_company_profile'].forEach((pm) => {
        clonedMap[pm] = true;
      });
    }

    // Edit Ap Company Profile
    if (clonedMap['update_ap_company']) {
      ['view_ap_company_profile'].forEach((pm) => {
        clonedMap[pm] = true;
      });
    }

    return clonedMap;
  }

  useEffect(() => {
    // setPermissions({});
  }, [userType]);

  return (
    <Card mb={6}>
      <CardContent>
        <Paper elevation={3} style={{ padding: '2%' }}>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={open}
            onClose={handleClose}
            key={vertical + horizontal}
          >
            {err ? (
              <Alert mt={2} mb={4} severity='error'>
                {err}
              </Alert>
            ) : success ? (
              <Alert mt={2} mb={4} severity='success'>
                Successfully Edited Role
              </Alert>
            ) : null}
          </Snackbar>
          {!loader ? (
            <Grid container spacing={5}>
              {/* <Grid item xs={12} md={12} lg={12}>
              <Typography variant="h4" gutterBottom>
                Edit Role and permissions
              </Typography>
            </Grid> */}
              <Button
                ref={snackRef}
                style={{ display: 'none' }}
                onClick={handleClick({ vertical: 'top', horizontal: 'center' })}
              >
                Click
              </Button>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  value={roleName}
                  onChange={(e) => setRoleName(e.target.value)}
                  required
                  id='standard-required'
                  label='Role Name'
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  value={_.upperCase(userType)}
                  inputProps={{ readOnly: true }}
                  label='User Type'
                />
              </Grid>
              {/* <Grid item xs={12} md={12} lg={12}>
                <Typography variant="h6">Select Permissions</Typography>
              </Grid> */}
              <Grid container spacing={3} sx={{ paddingLeft: 8, mt: 3 }}>
                {userType === 'ap_company_user' &&
                  authData?.type !== 'customer_user' &&
                  Object.keys(apPermission).map((type) => {
                    return (
                      <Grid item xs={12} md={4} lg={3} sx={{ border: '2px solid #f0f0f0' }}>
                        <Typography variant='h6'>{_.upperCase(type)}</Typography>
                        {apPermission[type].map((permission) => {
                          return (
                            <FormGroup>
                              <FormControl fullWidth component='fieldset' variant='standard'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={permissions[permission] || false}
                                      onChange={handleChange}
                                      name={permission}
                                    />
                                  }
                                  label={_.upperCase(permission)}
                                />
                              </FormControl>
                            </FormGroup>
                          );
                        })}
                      </Grid>
                    );
                  })}
              </Grid>

              <Grid container spacing={3} sx={{ paddingLeft: 8, mt: 3 }}>
                {userType === 'customer_company_user' &&
                  Object.keys(customerPermission).map((type) => {
                    return (
                      <Grid item xs={12} md={4} lg={3} sx={{ border: '2px solid #f0f0f0' }}>
                        <Typography variant='h6'>{_.upperCase(type)}</Typography>

                        {customerPermission[type].map((permission) => {
                          return (
                            <FormGroup>
                              <FormControl fullWidth component='fieldset' variant='standard'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={permissions[permission] || false}
                                      onChange={handleChange}
                                      name={permission}
                                    />
                                  }
                                  label={_.upperCase(permission)}
                                />
                              </FormControl>
                            </FormGroup>
                          );
                        })}
                      </Grid>
                    );
                  })}
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <Button
                  onClick={EditRole}
                  style={{ textAlign: 'center' }}
                  variant='contained'
                  color='primary'
                >
                  Save Changes
                </Button>
              </Grid>
            </Grid>
          ) : (
            <Loading />
          )}
        </Paper>
      </CardContent>
    </Card>
  );
}

function EditRole() {
  const [loader, setLoader] = useState(true);
  const location = useLocation();
  const [role, setRole] = useState([]);
  useEffect(() => {
    setRole(location?.state?.role);
    setLoader(false);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              EDIT ROLE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Link component={NavLink} to='/dashboard/roles'>
                View Roles
              </Link>
              <Typography>Edit Role</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <DefaultTextFields role={role} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default EditRole;
